import { render } from "./Pan.vue?vue&type=template&id=541d4f3b&lang=pug"
import script from "./Pan.vue?vue&type=script&lang=js"
export * from "./Pan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__